import { css } from '@emotion/react';

export const getIconCss = (colour) => css`
    path {
        stroke: ${colour};
    }

    path[fill] {
        fill: ${colour};
    }

    circle[fill] {
        fill: ${colour};
    }

    display: flex;
`;

export const smallSize = css`
    width: 16px;
    height: 16px;
`;

export const mediumSize = css`
    width: 24px;
    height: 24px;
`;
